import styled from "styled-components"

export const IconContainer = styled.div`
  cursor: pointer;
  margin-left: 2.8rem;
  padding-top: 8px;
`

export default IconContainer
